<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <h1 class="ml-3 mb-2">
      {{ $t("geral.edit") }}
    </h1>

    <b-row class="mb-3 ml-3">
      <router-link :to="getUrl">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
      <div class="ml-2">
        <b-button
          v-if="model.active == 'Sim'"
          size="sm"
          @click="disableProcess"
        >
          {{ $t("geral.delete") }}
        </b-button>
        <b-button v-if="model.active == 'Não'" size="sm" @click="activeProcess">
          {{ $t("geral.activate") }}
        </b-button>
      </div>
    </b-row>

    <div>
      <process-filled-detail-crud :value="model" :modelstate="modelstate">
      </process-filled-detail-crud>
    </div>
    <b-button
      class="button ml-3"
      size="sm"
      @click="saveProcess"
      :disabled="submitted"
    >
      {{ $t("workflow.processSave") }}
    </b-button>
    <!-- historico -->
    <div v-if="getPermission()">
      <process-story class="mt-5" :id="id"></process-story>
    </div>
    <!-- <div>{{ ownFilled }}</div> -->
    <!-- <div><pre class="language-json"><code>{{ model  }}</code></pre></div> -->
    <!-- {{ model }} -->
    <!-- <div>{{ modelstate }}</div> -->
    <!-- {{id}} -->
  </b-container>
</template>
<script>
export default {
  name: "ProcessFilledDetail",
  props: {
    id: String,
    perimission: Object,
    processName: String,
    processId: Number,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ProcessFilledDetailCrud: () =>
      import("@/components_rms/workflow/Process/ProcessFilledDetailCrud.vue"),
    ProcessStory: () =>
      import("@/components_rms/workflow/Process/ProcessStory.vue"),
  },
  data() {
    return {
      submitted: false,
      alert: {
        error: "",
        success: "Processo editado com sucesso",
      },
      model: {},
      modelstate: {},
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    getUrl() {
      if (this.processName == null || this.processName == "")
        return `/workflow/process/filled/list`;

      return `/workflow/filled/${this.processName}/${this.processId}`;
    },
  },
  methods: {
    getPermission() {
      if (!this.model) return false;
      if (!this.model.permissions) return false;
      if (this.model.permissions.administrador) return true;
      if (this.model.permissions.gestor) return true;
      if (this.model.permissions.advancedOperator) return true;
      return false;
    },
    activeProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/processFilled/active/" + this.id)
        .then((response) => {
          this.submitted = false;
          this.model.active = "Sim";
          this.$forceUpdate;
        });
    },
    disableProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/processFilled/disable/" + this.id)
        .then((response) => {
          this.submitted = false;
          this.model.active = "Não";
          this.$forceUpdate;
        });
    },
    loadData() {
      this.$apiWorkflow.get("/filled/detail/" + this.id).then((response) => {
        // console.log(response.data);
        this.model = response.data;
      });
    },
    saveProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/fieldValue/save/", this.model)
        .then((response) => {
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = {};
              }
              if (error.response.data && error.response.data.detail) {
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data.detail}`;
                this.$refs.danger.show();
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                this.$refs.danger.show();
              }
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
  },
};
</script>
